import { Injectable } from "@angular/core";
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
 @Injectable()
 export class CustomADateAdapter extends NgbDateAdapter<string> {
 
   readonly DELIMITER = '-';
 
   fromModel(value: unknown): NgbDateStruct | null {
     if (value instanceof Date) {
       if (Number.isNaN(value.getTime())) {
         return null;
       }

       return {
         day: value.getDate(),
         month: value.getMonth() + 1,
         year: value.getFullYear()
       };
     }

     if (typeof value === 'object' && value !== null) {
       const { year, month, day } = value as Partial<NgbDateStruct>;
       if (
         typeof year === 'number' &&
         typeof month === 'number' &&
         typeof day === 'number' &&
         Number.isInteger(year) &&
         Number.isInteger(month) &&
         Number.isInteger(day) &&
         year > 0 &&
         month >= 1 &&
         month <= 12 &&
         day >= 1 &&
         day <= new Date(year, month, 0).getDate()
       ) {
         return { year, month, day };
       }
       return null;
     }

     if (typeof value === 'string' && value) {
       const date = value.split(this.DELIMITER);
       return {
         day : parseInt(date[2], 10),
         month : parseInt(date[1], 10),
         year : parseInt(date[0], 10)
       };
     }
     return null;
   }
 
   toModel(date: NgbDateStruct | null): string | null {
     return date ? date.year + this.DELIMITER + ('0'+date.month).slice(-2) + this.DELIMITER + ('0'+date.day).slice(-2) : null;
   }
 }
 
